(function () {
  function initLiveVideoPip(root) {
    if (!root || root.dataset.liveVideoPipInitialized === 'true') return;

    var container = root.querySelector('[data-live-video-container]');
    var shell = root.querySelector('[data-live-video-pip-shell]');
    var closeButton = root.querySelector('[data-pip-close]');

    if (!container || !shell) return;

    root.dataset.liveVideoPipInitialized = 'true';

    if (root.dataset.pipEnabled !== 'true') return;

    var threshold = parseFloat(root.dataset.pipThreshold || '10') / 100;

    if (Number.isNaN(threshold)) {
      threshold = 0.1;
    }

    var pipDismissed = false;

    function setPipActive(active) {
      shell.classList.toggle('is-pip-active', active);
    }

    function updatePipState(isIntersecting) {
      if (isIntersecting) {
        pipDismissed = false;
        setPipActive(false);
        return;
      }

      if (!pipDismissed) {
        setPipActive(true);
      }
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          updatePipState(entry.isIntersecting);
        });
      },
      {
        root: null,
        threshold: threshold,
      }
    );

    observer.observe(container);

    if (closeButton) {
      closeButton.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        pipDismissed = true;
        setPipActive(false);
      });
    }
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-live-video-pip]');
    roots.forEach(initLiveVideoPip);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
